import React from 'react';
import ReactDOM from 'react-dom';
import { ContextMenuTrigger } from "react-contextmenu";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Select from 'react-select';
import tr from 'date-fns/locale/tr';
import PopupModal from '../../components/popup-modal/popup-modal.component';
import LoadingIndicator from '../../components/loading-indicator/loading-indicator.component';
import ReactTooltip from "react-tooltip";
import JqueryConfirm from '../jquery-confirm/jquery-confirm.component';
import { showWarningLayer, showWarningLayerPopup, hideWarningLayerPopup, generateID } from '../../utils/utils';
import WarningLayerPopup from '../warning-layer-popup/warning-layer-popup.component';
import LoadingLayer from '../loading-layer/loading-layer.component';
import * as actionCreators from '../../redux/login/login.actions';
import { LoginActionTypes } from '../../redux/login/login.types';
import { ProjectActionTypes } from '../../redux/project/project.types';
import { DefinitionsActionTypes } from '../../redux/definitions/definitions.types';
import axios from 'axios';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-tabs/style/react-tabs.css';
import './drivers.styles.scss';
import '../../assets/styles/react-bootstrap-table-all.min.css';
import '../../assets/styles/react-contextmenu.css';

//JQUERY CONFIRM DIALOG BOX
const confirmDialog = (open = false, type = 'alert', text = '', action) => () => {
  ReactDOM.render(
      <JqueryConfirm open={open} type={type} action={action}>
        <p className="text-center passwordInfo"><b>{text}</b></p>
      </JqueryConfirm>
   , document.getElementById('jqueryconfirm'));  
}


class Drivers extends React.Component {
  constructor(props){
    super(props);
    this.guid = generateID();
    this.excelData = [];
    this.state = {
      loading: false,
      loadingPopup:false,
      firstLoading:true,
      loadingModalNew: false,
      loadingModalEdit:true,
      selectedDriverID: null,
      selectedDriverData:null,
      modalNewSurucu:false,
      modalEditSurucu:false,
      isFilterDisable:true,
      isRowSelected: false,
      statusOption: {label: 'Aktif', value: 1},
      currentDriver:{
        USERNAME: '',
        PASSWORD: '',
        EMAIL: '',
        DISPLAYNAME: '',
        PHONENUMBER: '',
        IDNO: '',
        DRIVERTYPE:'',
        ISACTIVE:'',
        DRIVERID:''
      },
      columnFilterData:{}      
    }

  }


  componentDidMount(){
    this.getDrivers();
  }
  handleNewDriver = () => {
    this.props.setLoadingPopup(false);
    this.setState({...this.state,statusOption: {label: 'Aktif', value: 1}, modalNewSurucu:true});    
  }

  handleEditDriver = () => {
    this.props.setLoadingPopup(false);
    if (this.state.selectedDriverData === null){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen sürücü seçiniz.'});
      showWarningLayer();
      return;      
    }        

    this.setState({
      ...this.state,
      statusOption: this.state.selectedDriverData !== null ? {label: this.state.selectedDriverData.ISACTIVE === "1" ? 'Aktif' : 'Pasif', value: this.state.selectedDriverData.ISACTIVE === "1" ? 1 : 0} : null,
      modalEditSurucu: true
    });
    
  }

  insertDriver = async () => {
    this.props.setLoadingPopup(true);
    let username = this.username.value;  
    let password = this.password.value;  
    let repassword = this.repassword.value;
    let email = this.email.value;  
    let displayname = this.displayname.value;
    let phonenumber = this.phone.value;
    let idno = this.idno.value;
    let drivertype = this.drivertype.value;
    let isactive = this.state.statusOption.value;

    if (username === ""){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen kullanıcı adını kontrol edin. '});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }

    if (displayname === ""){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen ad / soyad alanını kontrol edin.'});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }    

    if (password === ""){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen şifre alanını kontrol edin.'});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }

    if (repassword === ""){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen şifre tekrar alanını kontrol edin.'});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    } 
    
    if (password !== repassword){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen şifre alanları uyumsuz.'});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;      
    }
    

    // if (email === ""){
    //   this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen e-posta alanını kontrol edin. '});
    //   showWarningLayerPopup();
    //   this.props.setLoadingPopup(false);
    //   return false;
    // }    

    const res = await axios.post(`https://azr05.infotraq.com/servisradarsu/add-driver`,
      {
        "sid": this.props.user.SessionID,
        "username": username,
        "displayname":displayname,
        "password":password,
        "email":email,
        "phonenumber":phonenumber,
        "idno":idno,
        "drivertype":drivertype,
        "isactive":isactive
      },
      {crossDomain: true});
    if (res.data.type === "error"){
      if (res.data.message === "DP_Session"){
        this.props.logOut();
        this.props.setDefault();
        const bodyElement = document.querySelector('body');
        bodyElement.classList.remove('noBodyImage');   
        this.props.setLoadingPopup(false);       
      }else if (res.data.message === "DP_Username"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen kullanıcı adını kontrol edin.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else if (res.data.message === "DP_Displayname"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen ad / soyad alanını kontrol edin.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else if (res.data.message === "DP_Password"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen şifre alanlarını kontrol edin.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else if (res.data.message === "DP_Email"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen e-posta alanını kontrol edin.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else{
        this.props.setLoadingPopup(false);
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Bir hata oluştu.Lütfen tekrar deneyiniz.'});
        showWarningLayerPopup();        
      }
    } else{
      if (res.data.message === "DP_Done"){
        this.props.setLoadingPopup(false);
        this.props.onWarning({warningMessageType:'success', warningMessageText: 'Sürücü eklendi.'});
        showWarningLayer();
        this.props.setLoading(true);
        this.getDrivers();
        this.setState({...this.state,modalNewSurucu:false});
      }else{
        this.props.setLoadingPopup(false);
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Bir hata oluştu.Lütfen tekrar deneyiniz.'});
        showWarningLayerPopup();
      }
      
    } 
  }
  updateDriver = async () => {
    this.props.setLoadingPopup(true);
    let driverid = this.state.selectedDriverData.DRIVERID;
    let username = this.username.value;  
    let password = this.password.value;  
    let repassword = this.repassword.value;
    let email = this.email.value;  
    let displayname = this.displayname.value;
    let phonenumber = this.phone.value;
    let idno = this.idno.value;
    let drivertype = this.drivertype.value;
    let isactive = this.state.statusOption.value;

    if (driverid === "" || driverid === null){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen sürücü seçiniz. '});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }

    if (username === ""){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen kullanıcı adını kontrol edin. '});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }

    if (displayname === ""){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen ad / soyad alanını kontrol edin.'});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;
    }    
 

    if (password !== repassword){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen şifre alanları uyumsuz.'});
      showWarningLayerPopup();
      this.props.setLoadingPopup(false);
      return false;      
    }

    
    if (password === ""){
      password = this.state.selectedDriverData.PASSWORD;
    }

    // if (email === ""){
    //   this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen e-posta alanını kontrol edin.'});
    //   showWarningLayerPopup();
    //   this.props.setLoadingPopup(false);
    //   return false;
    // }    

    const res = await axios.post(`https://azr05.infotraq.com/servisradarsu/update-driver`,
      {
        "sid": this.props.user.SessionID,
        "username": username,
        "displayname":displayname,
        "password":password,
        "email":email,
        "phonenumber":phonenumber,
        "idno":idno,
        "drivertype":drivertype,
        "isactive":isactive,
        "driverid":driverid
      },
      {crossDomain: true});
    if (res.data.type === "error"){
      if (res.data.message === "DP_Session"){
        this.props.logOut();
        this.props.setDefault();
        const bodyElement = document.querySelector('body');
        bodyElement.classList.remove('noBodyImage');   
        this.props.setLoadingPopup(false);       
      }else if (res.data.message === "DP_Username"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen kullanıcı adını kontrol edin.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else if (res.data.message === "DP_Displayname"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen ad / soyad alanını kontrol edin.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else if (res.data.message === "DP_Password"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen şifre alanlarını kontrol edin.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else if (res.data.message === "DP_Email"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen e-posta alanını kontrol edin.'});
        showWarningLayerPopup();
        this.props.setLoadingPopup(false);
      }else{
        this.props.setLoadingPopup(false);
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Bir hata oluştu.Lütfen tekrar deneyiniz.'});
        showWarningLayerPopup();        
      }
    } else{
      if (res.data.message === "DP_Done"){
        this.props.setLoadingPopup(false);
        this.props.onWarning({warningMessageType:'success', warningMessageText: 'Sürücü güncellendi.'});
        showWarningLayer();
        this.props.setLoading(true);
        this.getDrivers();
        this.setState({...this.state,modalEditSurucu:false});
      }else{
        this.props.setLoadingPopup(false);
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Bir hata oluştu.Lütfen tekrar deneyiniz.'});
        showWarningLayerPopup();
      }
      
    } 
  }  

  deleteDriver = async () => {
    this.props.setLoading(true);
    let driverid = this.state.selectedDriverData.DRIVERID;
    const res = await axios.post(`https://azr05.infotraq.com/servisradarsu/delete-driver`,
      {
        "sid": this.props.user.SessionID,
        "driverid":driverid
      },
      {crossDomain: true});
    if (res.data.type === "error"){
      if (res.data.message === "DP_Session"){
        this.props.logOut();
        this.props.setDefault();
        const bodyElement = document.querySelector('body');
        bodyElement.classList.remove('noBodyImage');          
      }else if (res.data.message === "DP_Busid"){
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen sürücü seçiniz.'});
        showWarningLayer();
        this.props.setLoading(false);
      }
    } else{
      if (res.data.message === "DP_Done"){
        this.props.setLoading(false);
        this.props.onWarning({warningMessageType:'success', warningMessageText: 'Sürücü silindi.'});
        this.getDrivers();
        showWarningLayer();
      }else{
        this.props.setLoading(false);
        this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Bir hata oluştu.Lütfen tekrar deneyiniz.'});
        showWarningLayer();
      }
      
    } 
  }


  handleFilterSearch = (value) => {
    try{
      this.refs.displaynameCol.applyFilter(value);
    }catch(ex){}
    
  }

  getDrivers = () => {
    this.setState({
      ...this.state,
      isFilterDisable:true,
      loading:true
    });
    axios.post(`https://azr05.infotraq.com/servisradarsu/get-drivers`,{ "sid": this.props.user.SessionID},{crossDomain: true})
    .then(res => {
      if (res.data.type === "error"){
        if (res.data.message === "DP_Session"){
          this.props.logOut();
          this.props.setDefault();
          const bodyElement = document.querySelector('body');
          bodyElement.classList.remove('noBodyImage');          
        }
      } else{
        let drivers;
        try{
          drivers = res.data.data;
          if (drivers === null || drivers === undefined){
            drivers = [];
          }
        }catch(ex){
          drivers = [];
        }
        
        this.props.setExcelData(drivers);
        this.setState({...this.state,isFilterDisable:false,firstLoading:false, loading:false});
        this.props.setDrivers(drivers);
        this.props.setLoading(false);
      }     
    })
  }

  handleStatusChange = statusOption => {
    this.setState(
      { statusOption });
  };  

  handleRowSelect = (row, isSelected, e) => {
    this.setState(
      {
      ...this.state,
      selectedDriverData: row,
      isRowSelected: isSelected
      }
      );
  }    

  handleDeleteDriver = () => {
    if (this.state.isRowSelected === false){
      this.props.onWarning({warningMessageType:'fail', warningMessageText: 'Lütfen sürücü seçiniz.'});
      showWarningLayer();
      return;      
    }    

    confirmDialog(true,'changepassword','Seçilen sürücüyü silmek istediğinize emin misiniz ?',() => this.deleteDriver())();    

  }  


  //Column Templates
  suColumnType = (cell, row, type) => {
    if (type === "isactive"){
      return cell === "1" ? '<span class="badge badge-success columnInfo">Aktif</span>' : '<span class="badge badge-danger columnInfo">Pasif</span>'
    }
  }    


  afterColumnFilter = (filterConds, result) => {
    //console.log(filterConds);
    const tempData = this.props.excelData;
    if (JSON.stringify(tempData) !== JSON.stringify(result)){
      this.props.setExcelData(result);
    }

    if (JSON.stringify(this.state.columnFilterData) !== JSON.stringify(filterConds)){    
      this.setState({
        ...this.state,
        columnFilterData: filterConds
      });
    }
  }

  render(){
    const durumOptions = [
      { value: 0, label: 'Pasif' },
      { value: 1, label: 'Aktif' }
    ];     
    const editGuid = generateID();
    //let tempDate = formatNow(new Date(),"YYYY-MM-DD");
    //const excelFileName = tempDate;
    const options = {
      sizePerPageList: [],
      hidePageListOnlyOnePage: true,
      sizePerPage: 50,
      noDataText: 'Gösterilecek kayıt yok',
      afterColumnFilter: this.afterColumnFilter,
    };    
    const selectRow = {
      mode: 'radio',  // multi select
      clickToSelect: true,
      className: 'row-select-class',
      bgColor: '#004288',
      Color:'white',
      onSelect: this.handleRowSelect,
      selected: this.state.selectedDriverData !== null ? [this.state.selectedDriverData.DRIVERID] : []      
    };   
    const footerData = [
      [
        {
          label: '',
          columnIndex: 1,
          align: 'left',
          formatter: (tableData) => {
            //let total = tableData.length;
            let total = this.props.excelData.length;
            return (
              <strong>Toplam : { total } sürücü</strong>
            );
          }
          
        }
      ]
    ];    

    const driverStatTypes = {
      0: 'Pasif',
      1: 'Aktif'
    };    
    

    return(
      <div className="passengersPageWrapper">
      <div className="card card-body bg-light content-toolbar">
      <div className="d-flex">
          <div className="p-2">
            <button type="button" className="btn btn-sm btn-general btn-light p-2 margin-left-5 userbuttons minibuttons" data-tip="Sürücü Ekle" onClick={() => this.handleNewDriver()}><i className="fas fa-plus"></i></button>
            <button type="button" className="btn btn-sm btn-general btn-light margin-left-5 userbuttons minibuttons " data-tip="Sürücü Düzelt" onClick={() => this.handleEditDriver()}><i className="fas fa-edit"></i> </button>
            <button type="button" className="btn btn-sm btn-general btn-light margin-left-5 userbuttons minibuttons " data-tip="Sürücü Sil" onClick={() => this.handleDeleteDriver()}><i className="fas fa-times"></i> </button>
          </div>
          <div className="ml-auto p-2">
            <div className="d-flex">
               <label className="filterLabelYolcuIslemleri">Filtrele :</label><input id="editFilter" type="text" disabled={this.state.isFilterDisable} className="form-control edit editFilter margin-right-5" placeholder="Sürücü Adı veya Soyadı" onChange={(event) => this.handleFilterSearch(event.target.value)}  />
            </div>              
          </div>
      </div>   
      </div>       
        <div className="SplitterPanelLeft">
        <ContextMenuTrigger id="submenu1" holdToDisplay={1000}>            
        {
          this.state.firstLoading ? <LoadingIndicator /> :
          this.props.drivers.length > 0 ? (
            <BootstrapTable data={ this.props.drivers } container className='driver-list surucu-tanimlari-table' hover options={options}  selectRow={ selectRow } footerData={ footerData } footer pagination >
              <TableHeaderColumn dataField='DRIVERID' isKey={true} hidden>ID</TableHeaderColumn>
              <TableHeaderColumn dataField='DISPLAYNAME' width='250px' ref='displaynameCol' className="displayCol" filter={ { type: 'TextFilter', delay: 1000}}  dataSort={ true } headerAlign='center'>Ad / Soyad</TableHeaderColumn>
              <TableHeaderColumn dataField='USERNAME' width='180px' dataSort={ true } dataAlign='center' headerAlign='center'>Kullanıcı Adı</TableHeaderColumn>
              <TableHeaderColumn dataField='EMAIL' width='250px' dataSort={ true } dataAlign='center'>E-Posta</TableHeaderColumn>
              <TableHeaderColumn dataField='PHONENUMBER' width='200px' ref='phonenumberCol' className="displayCol" dataSort={ true } dataAlign='center' headerAlign='center'>Telefon Numarası</TableHeaderColumn>
              <TableHeaderColumn dataField='IDNO' width='130px'  ref='idnoCol' className="displayCol"  dataSort={ true } headerAlign='center'>Sicil No</TableHeaderColumn>
              <TableHeaderColumn dataField='DRIVERTYPE' width='150px'  ref='activetoCol' className="displayCol" dataSort={ true } dataAlign='center' headerAlign='center'>Sürücü Tipi</TableHeaderColumn>
              <TableHeaderColumn dataField='ISACTIVE' width='100px' ref='isactiveCol' className="displayCol" dataSort={ true } dataAlign='center' headerAlign='center' filterFormatted formatExtraData={ driverStatTypes } dataFormat={(cell,row) => this.suColumnType(cell,row,'isactive') }>Durum</TableHeaderColumn>
              
          </BootstrapTable>          
          ) : 
          <p className="padding15">Gösterilecek kayıt yok.</p>
        }              
        </ContextMenuTrigger>        
                        
          {
            <table id="emp-arac-tanimlari" className="excel-table">  
            <tbody>             
              <tr>
                <td><b>Ad / Soyad {this.state.columnFilterData === null || this.state.columnFilterData === undefined ? '' : Object.keys(this.state.columnFilterData).length === 0 ? '' : this.state.columnFilterData.DISPLAYNAME !== undefined && '*'}</b></td>
                <td><b>Kullanıcı Adı</b></td>
                <td><b>E-Posta</b></td>
                <td><b>Telefon Numarası</b></td>
                <td><b>Sicil No</b></td>
                <td><b>Sürücü Tipi</b></td>
                <td><b>Durum</b></td>
              </tr>                                   
                { 
                  this.props.excelData.map((p, index) => {  
                      return (
                      <tr key={index}>  
                        <td >{p.DISPLAYNAME}</td>  
                        <td >{p.USERNAME}</td>  
                        <td >{p.EMAIL}</td>  
                        <td >{p.PHONENUMBER}</td>  
                        <td >{p.IDNO}</td>  
                        <td >{p.DRIVERTYPE}</td>  
                        <td >{p.ISACTIVE === "1" ? "Aktif" : "Pasif" }</td>  
                      </tr>  
                      )
                  })  
                }  
                <tr>
                <td><b>Toplam</b></td>
                <td><b>{this.props.excelData.length}</b></td>
                <td><b></b></td>
                <td><b></b></td>
                <td><b></b></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>  
              </tbody>  
              </table>  
              
          }          
                  


        </div>
          <PopupModal
              show={this.state.modalNewSurucu}
              onHide={() => this.setState({...this.state,modalNewSurucu:false})}
              titlemodal={`Yeni Sürücü Ekle`}
              onClick={()=> this.insertDriver}
            >
            
            <p className="contentInfoText"><i className="fas fa-info-circle su-color"></i> Lütfen sürücü bilgilerini giriniz.</p>
            <form className="address-form" name="driver-form">
            <div className="form-row address-row">
              <div className="col-md-6 mb-6">
                <label htmlFor={`username_${this.guid}`}>Kullanıcı Adı : <span className="requiredFieldMark">*</span></label>
                <input type="text" className="form-control" id={`username_${this.guid}`}  ref={(ref)=>{ this.username = ref;}} placeholder="Kullanıcı Adı zorunlu"  required />
              </div>
              <div className="col-md-6 mb-6">
                <label htmlFor={`displayname_${this.guid}`}>Ad / Soyad : <span className="requiredFieldMark">*</span></label>
                <input type="text" className="form-control" id={`displayname_${this.guid}`}  ref={(ref)=>{ this.displayname = ref;}} placeholder="Kullanıcı Adı zorunlu"  required  />
              </div>
            </div>
            <div className="form-row address-row">
              <div className="col-md-6 mb-6">
                <label htmlFor={`password_${this.guid}`}>Şifre : <span className="requiredFieldMark">*</span></label>
                <div className="clearfix"></div>
                <input type="password" id={`password_${this.guid}`} name={`password_${this.guid}`} ref={(ref)=>{ this.password = ref;}} autoCorrect="off" spellCheck="false" autoComplete="off"   className="form-control edit max-width-element" placeholder="Şifre" alt="Lütfen şifre alanını kontrol ediniz."  required />
              </div>
              <div className="col-md-6 mb-6">
                <label htmlFor={`repassword_${this.guid}`}>Şifre Tekrar : <span className="requiredFieldMark">*</span></label>
                <div className="clearfix"></div>
                <input type="password" id={`repassword_${this.guid}`} name={`repassword_${this.guid}`} ref={(ref)=>{ this.repassword = ref;}} autoCorrect="off" spellCheck="false" autoComplete="off"   className="form-control edit max-width-element" placeholder="Şifre tekrar" alt="Lütfen şifre alanını kontrol ediniz."  required />
              </div>
            </div>
            <div className="form-row address-row">
              <div className="col-md-6 mb-6">
                <label htmlFor={`email_${this.guid}`}>E-Posta Adresi : </label>
                <input type="text" className="form-control" id={`email_${this.guid}`}  ref={(ref)=>{ this.email = ref;}} placeholder="E-Posta adresi zorunlu"  required />
              </div>
              <div className="col-md-6 mb-6">
                <label htmlFor={`phone_${this.guid}`}>Telefon Numarası :</label>
                <input type="text" className="form-control" id={`phone_${this.guid}`}  ref={(ref)=>{ this.phone = ref;}} placeholder="Telefon Numarası"  />
              </div>
            </div>
            <div className="form-row address-row">
              <div className="col-md-6 mb-6">
                <label htmlFor={`idno_${this.guid}`}>Sicil No :</label>
                <input type="text" className="form-control" id={`idno_${this.guid}`}  ref={(ref)=>{ this.idno = ref;}} placeholder="Sicil No"  />
              </div>
              <div className="col-md-6 mb-6">
                <label htmlFor={`drivertype_${this.guid}`}>Sürücü Tipi :</label>
                <input type="text" className="form-control" id={`drivertype_${this.guid}`}  ref={(ref)=>{ this.drivertype = ref;}} placeholder="Sürücü Tipi"  />
              </div>
            </div>

            <div className="form-row address-row">
              <div className="col-md-6 mb-6">
                <label htmlFor={`isactive_${this.guid}`}>Durum :</label>
                <Select id={`isactive_${this.guid}`} className="edit max-width-element" placeholder="Durum" options={durumOptions} value={this.state.statusOption} onChange={this.handleStatusChange} />
              </div>
            </div>                                     
            </form>                

            <LoadingLayer showLoading={this.props.showLoadingPopup} />
            <WarningLayerPopup hideWarning={hideWarningLayerPopup} text={this.props.warningMessage} warningType={this.props.warningMessageType} />
          </PopupModal> 
          
          <PopupModal
            show={this.state.modalEditSurucu}
            onHide={() => this.setState({...this.state,modalEditSurucu:false})}
            titlemodal={`Sürücü Düzelt - ${this.state.selectedDriverData === null ? '' : this.state.selectedDriverData.DISPLAYNAME }`}
            onClick={()=> this.updateDriver}
            state={this.state}
          
          >
        
            <p className="contentInfoText"><i className="fas fa-info-circle su-color"></i> Lütfen sürücü bilgilerini giriniz.</p>
            <form className="address-form" name="driver-form">
            <div className="form-row address-row">
              <div className="col-md-6 mb-6">
                <label htmlFor={`username_${this.guid}`}>Kullanıcı Adı : <span className="requiredFieldMark">*</span></label>
                <input type="text" className="form-control" id={`username_${this.guid}`}  ref={(ref)=>{ this.username = ref;}} placeholder="Kullanıcı Adı zorunlu" defaultValue={this.state.selectedDriverData === null ? "" : this.state.selectedDriverData.USERNAME}  required />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor={`displayname_${this.guid}`}>Ad / Soyad : <span className="requiredFieldMark">*</span></label>
                <input type="text" className="form-control" id={`displayname_${this.guid}`}  ref={(ref)=>{ this.displayname = ref;}} placeholder="Ad / Soyad zorunlu" defaultValue={this.state.selectedDriverData === null ? "" : this.state.selectedDriverData.DISPLAYNAME}  required  />
              </div>
            </div>
            <div className="form-row address-row">
              <div className="col-md-6 mb-6">
                <label htmlFor={`password_${this.guid}`}>Şifre :</label>
                <div className="clearfix"></div>
                <input type="password" id={`password_${this.guid}`} name={`password_${this.guid}`} ref={(ref)=>{ this.password = ref;}} autoCorrect="off" spellCheck="false" autoComplete="off"   className="form-control edit max-width-element" placeholder="Şifre" alt="Lütfen şifre alanını kontrol ediniz."  required />
              </div>
              <div className="col-md-6 mb-6">
                <label htmlFor={`repassword_${this.guid}`}>Şifre Tekrar :</label>
                <div className="clearfix"></div>
                <input type="password" id={`repassword_${this.guid}`} name={`repassword_${this.guid}`} ref={(ref)=>{ this.repassword = ref;}} autoCorrect="off" spellCheck="false" autoComplete="off"   className="form-control edit max-width-element" placeholder="Şifre tekrar" alt="Lütfen şifre alanını kontrol ediniz."  required />
              </div>
            </div>
            <div className="form-row address-row">
              <div className="col-md-6 mb-6">
                <label htmlFor={`email_${this.guid}`}>E-Posta Adresi :</label>
                <input type="text" className="form-control" id={`email_${this.guid}`}  ref={(ref)=>{ this.email = ref;}} placeholder="E-Posta adresi zorunlu" defaultValue={this.state.selectedDriverData === null ? "" : this.state.selectedDriverData.EMAIL}  required />
              </div>
              <div className="col-md-6 mb-6">
                <label htmlFor={`phone_${this.guid}`}>Telefon Numarası :</label>
                <input type="text" className="form-control" id={`phone_${this.guid}`}  ref={(ref)=>{ this.phone = ref;}} placeholder="Telefon Numarası" defaultValue={this.state.selectedDriverData === null ? "" : this.state.selectedDriverData.PHONENUMBER}  />
              </div>
            </div>
            <div className="form-row address-row">
              <div className="col-md-6 mb-6">
                <label htmlFor={`idno_${this.guid}`}>Sicil No :</label>
                <input type="text" className="form-control" id={`idno_${this.guid}`}  ref={(ref)=>{ this.idno = ref;}} placeholder="Sicil No" defaultValue={this.state.selectedDriverData === null ? "" : this.state.selectedDriverData.IDNO}  />
              </div>
              <div className="col-md-6 mb-6">
                <label htmlFor={`drivertype_${this.guid}`}>Sürücü Tipi :</label>
                <input type="text" className="form-control" id={`drivertype_${this.guid}`}  ref={(ref)=>{ this.drivertype = ref;}} placeholder="Sürücü Tipi" defaultValue={this.state.selectedDriverData === null ? "" : this.state.selectedDriverData.DRIVERTYPE}  />
              </div>
            </div>
            <div className="form-row address-row">
              <div className="col-md-4 mb-4">
                <label htmlFor={`isactive_${editGuid}`}>Durum :</label>
                <Select id={`isactive_${editGuid}`} className="edit max-width-element" placeholder="Durum" options={durumOptions}  value={this.state.statusOption} onChange={this.handleStatusChange} />
              </div>
            </div>                
            </form>                
            <LoadingLayer showLoading={this.props.showLoadingPopup} />
            <WarningLayerPopup hideWarning={hideWarningLayerPopup} text={this.props.warningMessage} warningType={this.props.warningMessageType} />
        </PopupModal>           
      
      

            <ReactTooltip /> 
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.User,
    isLoading: state.login.isLoading,
    error: state.login.error,
    drivers: state.definitions.drivers,
    excelData: state.definitions.excelData,
    showLoading:state.login.showLoading,
    showLoadingPopup:state.login.showLoadingPopup,
    warningMessage: state.project.warningMessageText,
    warningType: state.project.warningMessageType
    
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logOut: () => dispatch(actionCreators.userLogout()),
    onWarning: (payload) => dispatch({ type: ProjectActionTypes.SET_WARNING_MESSAGE, payload: payload}),
    setLoading: (showLoading) => dispatch({ type: LoginActionTypes.SET_LOADING, showLoading: showLoading}),
    setLoadingPopup: (showLoadingPopup) => dispatch({ type: LoginActionTypes.SET_LOADING_POPUP, showLoadingPopup: showLoadingPopup}),
    setDefault: () => dispatch({ type: ProjectActionTypes.SET_DEFAULT}),
    setDrivers: (drivers) => dispatch({ type: DefinitionsActionTypes.SET_DRIVERS, drivers: drivers}),
    setExcelData: (excelData) => dispatch({ type: DefinitionsActionTypes.SET_EXCEL_DATA, excelData: excelData})
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Drivers));